// components
import { IOption } from 'components/FormElements/Select'
// types
import { InjuryMasterEnvironment } from 'types/graphql'

export const ENVIRONMENT_OPTIONS: IOption[] = [
  { label: 'Production', value: InjuryMasterEnvironment.Production },
  { label: 'Staging', value: InjuryMasterEnvironment.Staging }
]
